import request from '@/utils/request';

// 默认显示模块权限。只有打包时显式写成 false 才隐藏。
export const moduleAccessAdminEnabled = process.env.VUE_APP_MODULE_ACCESS_ADMIN_ENABLED !== 'false';
// API 位于学生业务服务；线上该前缀须转发到能发现 miniprogram 的网关。
// baseURL 已由公共 request 管理，不在这里重复拼接开发代理 /api。
const base = '/mobile/admin/module-access';

/**
 * 统一 HTTP 与业务成功校验；silentError 只让页面集中显示错误，仍保留失败 Promise。
 * 并发冲突、越权及配置错误不能返回成功或由前端自行降级。
 */
async function send(method, url, data, params) {
  const response = await request({ method, url: base + url, data, params, silentError: true });
  if (!response || !response.data || response.data.code !== 0) {
    throw new Error((response && response.data && response.data.message) || '权限配置请求失败');
  }
  return response.data.data;
}
export const getAccessTypes = () => send('get', '/types');
export const getAccessMinis = () => send('get', '/minis');
export const classifyModule = (rule, expected) => send('post', '/classification', { rule, expected });
export const getAccessState = (miniid, bookid) => send('get', '/mini/' + miniid, null, bookid ? { bookid } : {});
// expected 是页面读取时的完整旧规则；后端锁定并比对后才写入，新建时可为 null。
export const saveAccessRule = (rule, expected) => send('put', '/rule', { rule, expected });
// 恢复继承保留归类；后端仍校验旧值和收费旧协议保护。
export const resetAccessException = (rule, expected) => send('post', '/rule/reset', { rule, expected });
